import './LoadingSpinner.css';

export default function LoadingSpinner({
  message = "",
  variant = "default"
}) {
  return (
    <div className={`loading-spinner loading-spinner--${variant}`}>
      <div className="spinner" />
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
}
